// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface InlineLoadingSpinnerSignature {
  Args: {
    promise?: PromiseLike<unknown> | null;
  };
}

export default class InlineLoadingSpinner extends Component<InlineLoadingSpinnerSignature> {
  @tracked showSpinner = false;

  onPromiseChange = (): void => {
    this.showSpinner = true;

    const { promise } = this.args;
    if (promise) {
      void Promise.resolve(promise).finally(() => {
        this.showSpinner = false;
      });
    }
  };

  <template>
    {{! Wrapper div preserves the classic-component DOM and anchors did-update. }}
    <div data-test-inline-loading-spinner {{didUpdate this.onPromiseChange @promise}}>
      {{#if this.showSpinner}}
        <div class="search-loader">
          <svg class="circular" style="width:40px; height:40px;" viewBox="0 0 100 100">
            <circle class="circular-path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10" />
          </svg>
        </div>
      {{/if}}
    </div>
  </template>
}
